module.exports = __webpack_public_path__ + "lp/img/scaling_cursor_horizontal.869a912d.svg";